export default "__VITE_ASSET__5844776d__"